import React from "react";

const History = (props) => {
    return <><h1>History</h1></>
}

export default History;
